import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Aperture, LogOut, History as HistoryIcon, Sparkles, Shield } from "lucide-react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/login");
  };

  const linkCls = (path) =>
    `flex items-center gap-2 text-sm tracking-wide transition-colors ${
      location.pathname === path ? "text-amber-glow" : "text-neutral-400 hover:text-white"
    }`;

  return (
    <nav className="fixed top-0 inset-x-0 z-50 border-b border-white/10 bg-black/60 backdrop-blur-2xl">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/studio" data-testid="nav-logo" className="flex items-center gap-2.5">
          <Aperture className="h-6 w-6 text-amber-glow" strokeWidth={1.5} />
          <span className="font-display text-xl tracking-tight">Aevolux</span>
        </Link>
        {user && (
          <div className="flex items-center gap-7">
            <Link to="/studio" data-testid="nav-generator" className={linkCls("/studio")}>
              <Sparkles className="h-4 w-4" strokeWidth={1.5} /> Generator
            </Link>
            <Link to="/history" data-testid="nav-history" className={linkCls("/history")}>
              <HistoryIcon className="h-4 w-4" strokeWidth={1.5} /> History
            </Link>
            <Link to="/privacy" data-testid="nav-privacy" className={linkCls("/privacy")}>
              <Shield className="h-4 w-4" strokeWidth={1.5} /> Privacy
            </Link>
            <button
              data-testid="nav-logout"
              onClick={doLogout}
              className="flex items-center gap-2 text-sm text-neutral-400 hover:text-white transition-colors"
            >
              <LogOut className="h-4 w-4" strokeWidth={1.5} /> Logout
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
